<template>
  <div>
    <div class="app-wrapper" id="tracking-wrapper">
      <Form
        :externalBrand="brand"
        :externalPostcode="postcode"
        :externalShipment="shipment"
        @update-tracking-info="updateTrackingInfo"
        @update-pickup-info="updatePickupLocationInfo"
      />
      <template v-if="statusMessages.length > 0">
        <StatusBar
          v-for="(status, index) in statusMessages"
          :key="index"
          :message="status.message"
          :statusType="status.state"
        />
      </template>
      <DeliverySummary />
      <span v-if="isLoading" class="loading" style="display: block">Veuillez patienter</span>
    </div>
  </div>
</template>

<script>
import Form from './components/Form/Form.vue';
import StatusBar from './components/StatusBar/StatusBar.vue';
import DeliverySummary from './components/DeliverySummary/DeliverySummary.vue';
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  name: 'tracking',
  components: {
    Form,
    StatusBar,
    DeliverySummary,
  },
  props: {
    brand: String,
    shipment: String,
    postcode: String,
  },
  data() {
    return {
      trackingInfo: {
        trackingNumber: this.shipment,
        status: '',
        shipper: '',
        deliveryDate: '',
        deliveryTime: '',
      },
      pickupLocationInfo: {
        locationName: '',
        closingTime: '',
        address: '',
      },
    };
  },
  computed: {
    ...mapState(['statusMessages', 'isLoading']),
  },
  methods: {
    updateTrackingInfo(info) {
      this.trackingInfo = { ...this.trackingInfo, ...info };
    },
    updatePickupLocationInfo(info) {
      this.pickupLocationInfo = { ...this.pickupLocationInfo, ...info };
    },
    fetchRelayPoints() {
      axios.get('/api/parcelshop/relayPointsExcluded').then(res => {
        this.$store.commit('setRelayPointsExcluded', res.data);
      });
    },
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);

    if (params.has('shipment')) {
      this.shipment = params.get('shipment');
    }
    if (params.has('postcode')) {
      this.postcode = params.get('postcode');
    }
    if (params.has('brand')) {
      this.brand = params.get('brand');
    }
  },
};
</script>

<style lang="scss" scoped>
@import './assets/css/global';
</style>
